module.exports = __webpack_public_path__ + "img/awba.ab18fb76.png";